import React from 'react';

/**
 * Component to display a reservation type badge based on the reservation's type_name
 * Only shows Owner and Maintenance badges
 * @param {Object} reservation - The reservation object
 * @param {string} context - The context where this badge is being shown (e.g., 'reservations')
 */
function ReservationTypeBadge({ reservation, context = '' }) {
  // Define the standard indicator style
  const indicatorBaseStyle = "inline-flex items-center px-3 py-1 text-sm rounded-full";
  
  // Return null if no reservation is provided
  if (!reservation) {
    console.error('No reservation provided to ReservationTypeBadge');
    return null;
  }
  
  // Reuse the Owner badge for owner blocks and both owner guest types.
  const ownerRelatedTypes = ['OWN', 'NPG', 'PGO'];
  if (reservation.isOwnerBlock === true || 
      ownerRelatedTypes.includes(reservation.type_name)) {
   
    // Change text based on context
    const ownerText = context === 'reservations' ? 'Owner Block' : 'Owner Departure';
    const titleText = context === 'reservations' ? 'Owner reservation' : 'Owner just checked out';
    
    return (
      <span className={`${indicatorBaseStyle} bg-indigo-100 text-indigo-800`} title={titleText}>
        <svg className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
        </svg>
        {ownerText}
      </span>
    );
  }
  
  // Only show Maintenance Block  
  if (reservation.isMaintenanceBlock === true || 
      (reservation.type_name && reservation.type_name.toLowerCase() === 'maintenanceblock')) {
  
    return (
      <span className={`${indicatorBaseStyle} bg-orange-100 text-orange-800`}>
        <svg className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z" clipRule="evenodd" />
          <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
        </svg>
        Maintenance
      </span>
    );
  }
  
  // No badge for other reservation types
  return null;
}

export default ReservationTypeBadge;
